import { render, staticRenderFns } from "./Subjects.vue?vue&type=template&id=5b1037ce&"
import script from "./Subjects.vue?vue&type=script&lang=js&"
export * from "./Subjects.vue?vue&type=script&lang=js&"
import style0 from "./Subjects.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src1477836768/src/github.com/FebosIO/Febos-AMI/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5b1037ce')) {
      api.createRecord('5b1037ce', component.options)
    } else {
      api.reload('5b1037ce', component.options)
    }
    module.hot.accept("./Subjects.vue?vue&type=template&id=5b1037ce&", function () {
      api.rerender('5b1037ce', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/febos/chile/approvals/components/trays/managementTray/informationFlow/Subjects.vue"
export default component.exports